import React from 'react'
import { Dashboard } from './Dashboard'

export const MainPage: React.FC = () => {
  return <Dashboard />
}
